module.exports = __webpack_public_path__ + "static/media/img-02.557bc0f1.jpg";